var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.wrapClasses},[_c('span',{staticClass:"c-radio-item"},[_c('input',{class:_vm.inputClasses,attrs:{"type":"radio","disabled":_vm.disabled,"name":_vm.name},domProps:{"checked":_vm.currentValue},on:{"change":_vm.change}})]),_vm._t("default",function(){return [(_vm.showSlot)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }